// src/utils/analytics.js
// Google Analytics Event Tracking for FINNCAL

/**
 * Track custom events in Google Analytics
 * @param {string} eventName - Name of the event
 * @param {object} eventParams - Additional parameters
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

/**
 * Track when user clicks the login button (before Google popup)
 */
export const trackLoginStarted = () => {
  trackEvent('login_started', {
    method: 'google',
    event_category: 'authentication',
    event_label: 'Google OAuth Started',
  });
};

/**
 * Track when user successfully completes login
 */
export const trackLoginCompleted = (userId = null) => {
  trackEvent('login_completed', {
    method: 'google',
    event_category: 'authentication',
    event_label: 'Google OAuth Completed',
    user_id: userId,
  });
};

/**
 * Track when user saves a plan
 */
export const trackPlanSaved = (planName = 'unnamed') => {
  trackEvent('plan_saved', {
    event_category: 'engagement',
    event_label: planName,
  });
};
